<h1>Your Market Flips</h1>
<!-- MARK: Entitlements -->
<div class="entitlements">
  @if (userSettingsService.isLoggedIn$ | async) {
    @if (afmBeService.afmStripeUserData().entitlementsLookups.includes('flipper-masterpiece')) {
      <p>As a Masterpiece Supporter, you have unlimited access to the Albion Free Market Flipper. Thank you for supporting the project!</p>
    } @else if (afmBeService.afmStripeUserData().entitlementsLookups.includes('flipper-outstanding')) {
      <p>
        As an Outstanding Supporter, you can see all flips up to {{ SUB_LIMITS.flipper.outstanding | smallNumber }} profit. Thank you for supporting the
        project!
      </p>
      <p>If you want to change your supporter level, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    } @else if (afmBeService.afmStripeUserData().entitlementsLookups.includes('flipper-normal')) {
      <p>As a Normal Supporter, you can see all flips up to {{ SUB_LIMITS.flipper.normal | smallNumber }} profit. Thank you for supporting the project!</p>
      <p>If you want to change your supporter level, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    } @else {
      <p>Since you are not a supporter of Albion Free Market, you can only see flips up to {{ SUB_LIMITS.flipper.default | smallNumber }} profit.</p>
      <p>If you want to become a supporter, head over to the <a routerLink="/support-us">Support AFM</a> section.</p>
    }
  } @else {
    <div>
      You need to <button mat-flat-button color="accent" (click)="authService.googleSignIn()"><mat-icon>login</mat-icon>LOGIN</button> to use this tool.
    </div>
  }
</div>

@if ((userSettingsService.isLoggedIn$ | async) && (jsonReaderService.hasLoaded$ | async) && userFlipsResponse()) {
  <div style="margin-top: 15px">
    <p>
      You have completed {{ userFlipsResponse()!.flipsCount | number: '1.0-0' }} flips. Your total premium profit is
      {{ userFlipsResponse()!.totalProfitPremium | number: '1.0-0' }} silver. On average, you make
      {{ userFlipsResponse()!.averageProfitPremium | number: '1.0-0' }} silver per flip.
    </p>
    <p>
      You have completed {{ userFlipsResponse()!.normalFlipsCount | number: '1.0-0' }} non-upgrade flips. Your total premium profit for non-upgrade flips is
      {{ userFlipsResponse()!.totalProfitNormalPremium | number: '1.0-0' }} silver. On average, you make
      {{ userFlipsResponse()!.averageProfitNormalPremium | number: '1.0-0' }} silver per non-upgrade flip.
    </p>
    <p>
      You have completed {{ userFlipsResponse()!.upgradeFlipsCount | number: '1.0-0' }} upgrade flips. Your total premium profit for upgrade flips is
      {{ userFlipsResponse()!.totalProfitUpgradePremium | number: '1.0-0' }} silver. On average, you make
      {{ userFlipsResponse()!.averageProfitUpgradePremium | number: '1.0-0' }} silver per upgrade flip.
    </p>
    <p>Below you can see your latest flips data, up to a limit of 10 thousand flips.</p>
  </div>
}
<!-- MARK: Charts -->
<div style="display: flex; flex-wrap: wrap; gap: 20px; margin-top: 20px">
  <div style="flex: 1; min-width: 300px; height: 300px">
    <app-chart [data]="flipsProfitChartData()" [timeUnit]="selectedTimeUnit()" title="{{ selectTimeUnitDescriptor() }} Flip Profit (Premium)"></app-chart>
  </div>
  <div style="flex: 1; min-width: 300px; height: 300px">
    <app-chart [data]="flipsCountChartData()" [timeUnit]="selectedTimeUnit()" title="{{ selectTimeUnitDescriptor() }} Flip Count"></app-chart>
  </div>
</div>

<!-- MARK: Chart Time Unit Selection -->
<div style="margin-top: 15px">
  <mat-radio-group aria-label="Select chart time unit" [(ngModel)]="selectedTimeUnit" name="timeUnitGroup">
    @for (unit of timeUnits; track unit) {
      <mat-radio-button [value]="unit" style="margin-right: 10px">{{ unit | titlecase }}</mat-radio-button>
    }
  </mat-radio-group>
</div>

<!-- MARK: FILTER -->
<form [formGroup]="filterFormGroup" style="display: flex; flex-direction: row; width: 98%; margin-top: 15px">
  <mat-form-field style="flex: 1">
    <mat-label>Filter by Item Name</mat-label>
    <input matInput [formControl]="filterFormGroup.controls.filterInput" placeholder="Ex. Bag" #input />
    @if (filterFormGroup.controls.filterInput.value) {
      <button matSuffix mat-icon-button aria-label="Clear" (click)="filterFormGroup.controls.filterInput.setValue('')" aria-label="Clear Filter">
        <mat-icon>close</mat-icon>
      </button>
    }
  </mat-form-field>
  <mat-checkbox [formControl]="filterFormGroup.controls.onlyFailed" aria-label="Failed Flips Checkbox">Failed Flips<br />Only</mat-checkbox>
</form>
<!-- MARK: Table -->
<div class="table mat-elevation-z8 table" style="margin-top: 15px">
  <table mat-table [dataSource]="flipsDataSource" #flipsSort="matSort" matSort matSortStart="desc">
    <ng-container matColumnDef="itemUsCompleteName">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Item Name</th>
      <td mat-cell *matCellDef="let flip">
        <div style="display: flex; align-items: center">
          <div style="display: flex; flex-direction: column; align-items: center; padding-right: 5px; padding-top: 3px">
            @if (flip.isUpgrade) {
              <img [src]="imageService.getItemImageUrl(flip.boughtItem.uniqueName, undefined, 50)" [alt]="flip.boughtItem.LocalizedName" />
              <mat-icon matTooltip="This is an upgrade flip!" color="accent">arrow_drop_down</mat-icon>
            }
            <img [src]="imageService.getItemImageUrl(flip.soldItem.uniqueName, undefined, 50)" [alt]="flip.soldItem.LocalizedName" />
          </div>
          <div style="display: flex; flex-direction: column; align-items: start; text-align: start">
            @if (flip.isUpgrade) {
              <div>
                {{ flip.boughtItem.localizedName }}
              </div>
              <div>
                <app-copy-text-button [text]="flip.boughtItem.localizedName"></app-copy-text-button>
                <app-check-price-button [itemUniqueName]="flip.boughtItem.uniqueName"></app-check-price-button>
              </div>
            }
            <div>
              {{ flip.soldItem.localizedName }}
            </div>
            <div>
              <app-copy-text-button [text]="flip.soldItem.localizedName"></app-copy-text-button>
              <app-check-price-button [itemUniqueName]="flip.soldItem.uniqueName"></app-check-price-button>
            </div>
          </div>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="server">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Server</th>
      <td mat-cell *matCellDef="let flip">
        {{ getServerName(flip.server) }}
      </td>
    </ng-container>

    <ng-container matColumnDef="flipTime">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Flipped<br />At</th>
      <td mat-cell *matCellDef="let flip">
        <p>{{ flip.flipTime | date: 'shortDate' : 'UTC' }}</p>
        <p>{{ flip.flipTime | date: 'shortTime' : 'UTC' }}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="sellOrderUnitPriceSilver">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Buy From</th>
      <td mat-cell *matCellDef="let flip">
        <div class="stack-text">{{ flip.buyLocation.displayName }} - {{ flip.buyQuality.name }}</div>
        <div class="stack-text">
          {{ flip.buyPrice + flip.smugglersFee | number: '1.0-0' }} {{ flip.smugglersFee > 0 ? '[' + (flip.smugglersFee | number: '1.0-0') + ']' : '' }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="buyOrderUnitPriceSilver">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-160">Sell To</th>
      <td mat-cell *matCellDef="let flip">
        <div class="stack-text">{{ flip.sellLocation.displayName }} - {{ flip.sellQuality.name }}</div>
        <div class="stack-text">
          {{ flip.sellPrice | number: '1.0-0' }}
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="upgradeCost">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Upgrade<br />Cost</th>
      <td mat-cell *matCellDef="let flip">
        <p>{{ flip.upgradeCost | number: '1.0-0' }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="profitPremium">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit<br />(Premium)</th>
      <td mat-cell *matCellDef="let flip">
        <p>{{ flip.profitPremium | number: '1.0-0' }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="profitPercentagePremium">
      <th mat-header-cell *matHeaderCellDef mat-sort-header class="min-width-80">Profit %<br />(Premium)</th>
      <td mat-cell *matCellDef="let flip">
        <p>{{ flip.profitPercentagePremium | percent: '1.2-2' }}</p>
      </td>
    </ng-container>
    <ng-container matColumnDef="failed">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>Failed Flip<br />(Current Prices)</th>
      <td mat-cell *matCellDef="let flip" class="min-width-80">
        <div style="display: flex; flex-direction: column; gap: 10px; align-items: center; padding: 5px">
          <button
            [color]="flip.failedFlip ? 'accent' : 'warn'"
            mat-mini-fab
            (click)="updateFlipFailed(flip)"
            [disabled]="!enableUpdateFailFlipButton"
            class="mat-mini-fab small-mini-fab"
            aria-label="Update Fail Flip"
            [matTooltip]="flip.failedFlip ? 'Mark as successful flip' : 'Mark as failed flip'"
          >
            @if (flip.failedFlip) {
              <mat-icon>thumb_up</mat-icon>
            } @else {
              <mat-icon>thumb_down</mat-icon>
            }
          </button>
          @if (flip.failedFlip) {
            @let prices = getCurrentBlackMarketPrices(flip);
            @if (prices.length > 0) {
              @for (price of prices; track $index) {
                <div style="display: flex; gap: 5px; align-items: center; justify-content: space-between">
                  <div>
                    <div>{{ price.city.displayName }} - {{ price.qualityLevel.name }}</div>
                    <div>{{ price.buyPriceMax | number: '1.0-0' }}</div>
                    <div>{{ getAgeText(price) }} old</div>
                  </div>
                  @let profit = price.buyPriceMax * (1 - SALES_TAX) - (flip.buyPrice + (flip.smugglersFee || 0) + (flip.upgradeCost || 0));
                  @if (profit > 0) {
                    <mat-icon style="color: var(--profit-color)" [matTooltip]="'Profit: ' + (profit | number: '1.0-0')">trending_up</mat-icon>
                  } @else {
                    <mat-icon style="color: var(--loss-color)" [matTooltip]="'Loss: ' + (profit | number: '1.0-0')">trending_down</mat-icon>
                  }
                </div>
              }
            } @else {
              <div>Price not found</div>
            }
          }
        </div>
      </td>
    </ng-container>
    <ng-container matColumnDef="delete">
      <th mat-header-cell *matHeaderCellDef>Delete<br />Flip</th>
      <td mat-cell *matCellDef="let flip" class="min-width-80">
        <button
          color="warn"
          mat-mini-fab
          (click)="deleteFlip(flip)"
          [disabled]="!enableDeleteButton"
          class="mat-mini-fab small-mini-fab"
          aria-label="Delete Flip"
        >
          <mat-icon>delete</mat-icon>
        </button>
      </td>
    </ng-container>
    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns" [ngClass]="{ 'red-row': row.failedFlip }"></tr>
  </table>
</div>
<div>
  <mat-paginator #flipsPaginator [pageSizeOptions]="[25, 50, 100]" showFirstLastButtons aria-label="Select page of flips"> </mat-paginator>
</div>
